<template>
  <div class="col-md-4">
    <div class="info info-hover">
      <a :href="item.urlImage">
        <div class="icon icon-primary icon-circle">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i>
        </div>
        <h4 class="info-title">{{item.titulo}}</h4>
      </a>
      <p class="description">{{item.descripcion}}</p>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  props: ["item"],
  name: "formulario-detalle",
  components: {
    Card,
    Tabs,
    TabPane
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style>
</style>